import styled from "styled-components";

import { mapScaleToPixels, SpacingScales } from "../Spacings/helpers";

export type StackProps = {
  alignItems?: string;
  scale?: SpacingScales;
  usePxUnits?: boolean;
};

const Stack = styled.div<StackProps>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignItems || "stretch"};
  > * + * {
    margin: ${(props) =>
        mapScaleToPixels(props.scale || "small", props.theme, props.usePxUnits)}
      0 0 0;
  }
`;

export default Stack;
